import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from "@environments/environment";
import { Observable, of } from 'rxjs';
import { IMeasure, IMeasureDetail, ICriteria, IRule, ICreateComponentRequest, ICreateCriteriaGroupRequest, ICriteriaReorderRequest, IRuleReorderRequest, IUpdateMeasureRequest } from '@models/measures.model';
import { IDropdown } from '@models/dropdown.model';
import { Store } from '@ngrx/store';
import {  map } from 'rxjs/operators';

import * as fromMeasures from '../store/selectors/measures/measures.selectors';

@Injectable({
  providedIn: 'root'
})
export class MeasuresService {

  private readonly url: string = environment.apiUrl;

  constructor(private http: HttpClient, private store: Store) { }

  getMeasuresTableData(params: any): Observable<IMeasure[]> {
   let queryParms = new HttpParams();
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.get<IMeasure[]>(`${this.url}/measures`,{   
      headers,     
      params: queryParms
     })
  }

  getMeasureDetails(measureId: number): Observable<IMeasureDetail> { 
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.get<any>(`${this.url}/measures/${measureId}/details`,{ headers });
  }

  getMeasureAggregationTypes(): Observable<IDropdown[]>{
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.get<any>(`${this.url}/measures/measureaggregationtypes`,{ headers });
  };

  getMeasureCriteriaGroups(): Observable<IDropdown[]>{
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.get<any>(`${this.url}/measureComponents/criteriagrouptypes`,{ headers });
  };

  getMeasureTypes(): Observable<IDropdown[]>{
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.get<any>(`${this.url}/measures/measureTypes`,{ headers });
  };  

  createMeasureComponent(request: ICreateComponentRequest): Observable<any>{
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post<ICreateComponentRequest>(`${this.url}/measurecomponents`, request, { headers});
  }

  
  createCriteriaGroup(request: ICreateCriteriaGroupRequest): Observable<ICriteria>{
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post<ICriteria>(`${this.url}/measures/createPopulationCriteriaGroup`, request, { headers});
  }

  reorderCriteriaGroup(request: ICriteriaReorderRequest): Observable<boolean>{
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post<boolean>(`${this.url}/measures/updatePopulationCriteriaGroupSortOrder`, request, { headers});
  };

  reorderRuleGroup(request: IRuleReorderRequest): Observable<boolean>{
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post<boolean>(`${this.url}/rulegroups/updateRuleGroupSortOrder`, request, { headers});
  };

  addRuleItem(criteriaId : number, componentId: number): Observable<ICriteria[]>{
    const newRule : IRule = {
      id: -1,
      sortOrder: 1000
    }

    return this.store.select<ICriteria[]>(fromMeasures.selectCriteriaList).pipe(
      map(details => {
        details.find(c => { c.id == criteriaId })?.components.find( comp => { comp.id == componentId })?.rules.push(newRule);
        return details;
      })
    );
  }

  updateMeasureData(request: IUpdateMeasureRequest): Observable<IMeasure>{
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.patch<IMeasure>(`${this.url}/measures/${request.id}`, request, { headers});
  };

}

